import { render, staticRenderFns } from "./UploadTechnicalDocument.vue?vue&type=template&id=7f671697&"
import script from "./UploadTechnicalDocument.ts?vue&type=script&lang=ts&"
export * from "./UploadTechnicalDocument.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports